/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface TemplatesService {
  /**
   * @summary List Templates
   * @description List message templates with optional filters.
   */
  listTemplatesMessagingTemplatesGet: {
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<ListTemplatesMessagingTemplatesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: ListTemplatesMessagingTemplatesGetSchema,
        options: {
          parameters: ListTemplatesMessagingTemplatesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>>
    ): Promise<RequestFnResponse<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueryKey(
      parameters: DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void
    ): ServiceOperationQueryKey<ListTemplatesMessagingTemplatesGetSchema, ListTemplatesMessagingTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.templatesService.listTemplatesMessagingTemplatesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.templatesService.listTemplatesMessagingTemplatesGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListTemplatesMessagingTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.templatesService.listTemplatesMessagingTemplatesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.templatesService.listTemplatesMessagingTemplatesGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = ListTemplatesMessagingTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<
      ListTemplatesMessagingTemplatesGetSchema,
      ListTemplatesMessagingTemplatesGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.templatesService.listTemplatesMessagingTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListTemplatesMessagingTemplatesGetParameters,
      TQueryFnData = ListTemplatesMessagingTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, ListTemplatesMessagingTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.templatesService.listTemplatesMessagingTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends ListTemplatesMessagingTemplatesGetParameters,
      TQueryFnData = ListTemplatesMessagingTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, ListTemplatesMessagingTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListTemplatesMessagingTemplatesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const listTemplatesMessagingTemplatesGetTotal = qraft.templatesService.listTemplatesMessagingTemplatesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const listTemplatesMessagingTemplatesGetByParametersTotal = qraft.templatesService.listTemplatesMessagingTemplatesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const listTemplatesMessagingTemplatesGetResults = qraft.templatesService.listTemplatesMessagingTemplatesGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const listTemplatesMessagingTemplatesGetCombinedResults = qraft.templatesService.listTemplatesMessagingTemplatesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          ListTemplatesMessagingTemplatesGetSchema,
          ListTemplatesMessagingTemplatesGetParameters,
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.templatesService.listTemplatesMessagingTemplatesGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.templatesService.listTemplatesMessagingTemplatesGet.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = ListTemplatesMessagingTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          TData,
          ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<ListTemplatesMessagingTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.templatesService.listTemplatesMessagingTemplatesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends ListTemplatesMessagingTemplatesGetParameters,
      TData = ListTemplatesMessagingTemplatesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError,
          OperationInfiniteData<TData, ListTemplatesMessagingTemplatesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          ListTemplatesMessagingTemplatesGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, ListTemplatesMessagingTemplatesGetParameters>,
      OperationError<ListTemplatesMessagingTemplatesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary List Templates
     * @description List message templates with optional filters.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const listTemplatesMessagingTemplatesGetData = qraft.templatesService.listTemplatesMessagingTemplatesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const listTemplatesMessagingTemplatesGetCombinedData = qraft.templatesService.listTemplatesMessagingTemplatesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * listTemplatesMessagingTemplatesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          ListTemplatesMessagingTemplatesGetSchema,
          ListTemplatesMessagingTemplatesGetParameters,
          ListTemplatesMessagingTemplatesGetData,
          ListTemplatesMessagingTemplatesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<ListTemplatesMessagingTemplatesGetData>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<ListTemplatesMessagingTemplatesGetData>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    fetchInfiniteQuery<TPageParam extends ListTemplatesMessagingTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<
      OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
    >;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    prefetchInfiniteQuery<TPageParam extends ListTemplatesMessagingTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    ensureInfiniteQueryData<TPageParam extends ListTemplatesMessagingTemplatesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        ListTemplatesMessagingTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        ListTemplatesMessagingTemplatesGetError
      > | void
    ): Promise<
      OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
    >;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void)
    ): ListTemplatesMessagingTemplatesGetData | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void)
    ):
      | OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
      | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              ListTemplatesMessagingTemplatesGetSchema,
              ListTemplatesMessagingTemplatesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    ListTemplatesMessagingTemplatesGetData,
                    ListTemplatesMessagingTemplatesGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              ListTemplatesMessagingTemplatesGetSchema,
              ListTemplatesMessagingTemplatesGetParameters
            >,
            data: ListTemplatesMessagingTemplatesGetData | undefined,
          ]
        >;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | void)
    ): QueryState<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetError> | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<ListTemplatesMessagingTemplatesGetParameters>
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >
        | void
    ):
      | QueryState<
          OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>,
          ListTemplatesMessagingTemplatesGetError
        >
      | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | undefined)
        | ServiceOperationQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
      updater: Updater<
        NoInfer<ListTemplatesMessagingTemplatesGetData> | undefined,
        NoInfer<DeepReadonly<ListTemplatesMessagingTemplatesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): ListTemplatesMessagingTemplatesGetData | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<ListTemplatesMessagingTemplatesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                ListTemplatesMessagingTemplatesGetData,
                ListTemplatesMessagingTemplatesGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<ListTemplatesMessagingTemplatesGetData, ListTemplatesMessagingTemplatesGetParameters>
      | undefined;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      updater: Updater<
        NoInfer<ListTemplatesMessagingTemplatesGetData> | undefined,
        NoInfer<ListTemplatesMessagingTemplatesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<ListTemplatesMessagingTemplatesGetData | undefined>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        ListTemplatesMessagingTemplatesGetSchema,
        ListTemplatesMessagingTemplatesGetData,
        TInfinite,
        ListTemplatesMessagingTemplatesGetParameters,
        ListTemplatesMessagingTemplatesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): void;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary List Templates
     * @description List message templates with optional filters.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            ListTemplatesMessagingTemplatesGetSchema,
            ListTemplatesMessagingTemplatesGetData,
            TInfinite,
            ListTemplatesMessagingTemplatesGetParameters,
            ListTemplatesMessagingTemplatesGetError
          >
    ): number;
    schema: ListTemplatesMessagingTemplatesGetSchema;
    types: {
      parameters: ListTemplatesMessagingTemplatesGetParameters;
      data: ListTemplatesMessagingTemplatesGetData;
      error: ListTemplatesMessagingTemplatesGetError;
    };
  };
  /**
   * @summary Create Template
   * @description Create a new message template.
   */
  createTemplateMessagingTemplatesPost: {
    /**
     * @summary Create Template
     * @description Create a new message template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateTemplateMessagingTemplatesPostBody,
        CreateTemplateMessagingTemplatesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateTemplateMessagingTemplatesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateTemplateMessagingTemplatesPostBody,
          CreateTemplateMessagingTemplatesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<CreateTemplateMessagingTemplatesPostData, CreateTemplateMessagingTemplatesPostError>
      >
    ): Promise<RequestFnResponse<CreateTemplateMessagingTemplatesPostData, CreateTemplateMessagingTemplatesPostError>>;
    /**
     * @summary Create Template
     * @description Create a new message template.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateTemplateMessagingTemplatesPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateTemplateMessagingTemplatesPostSchema,
      CreateTemplateMessagingTemplatesPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.createTemplateMessagingTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.createTemplateMessagingTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateTemplateMessagingTemplatesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateTemplateMessagingTemplatesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateTemplateMessagingTemplatesPostSchema,
        CreateTemplateMessagingTemplatesPostData,
        CreateTemplateMessagingTemplatesPostParameters,
        TVariables,
        OperationError<CreateTemplateMessagingTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateTemplateMessagingTemplatesPostData,
      OperationError<CreateTemplateMessagingTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.createTemplateMessagingTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.createTemplateMessagingTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateTemplateMessagingTemplatesPostBody,
        CreateTemplateMessagingTemplatesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateTemplateMessagingTemplatesPostSchema,
        CreateTemplateMessagingTemplatesPostData,
        CreateTemplateMessagingTemplatesPostParameters,
        TVariables,
        OperationError<CreateTemplateMessagingTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateTemplateMessagingTemplatesPostData,
      OperationError<CreateTemplateMessagingTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createTemplateMessagingTemplatesPostTotal = qraft.templatesService.createTemplateMessagingTemplatesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createTemplateMessagingTemplatesPostTotal = qraft.templatesService.createTemplateMessagingTemplatesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTemplateMessagingTemplatesPostSchema,
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createTemplateMessagingTemplatesPostPendingMutationVariables = qraft.templatesService.createTemplateMessagingTemplatesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createTemplateMessagingTemplatesPostMutationData = qraft.templatesService.createTemplateMessagingTemplatesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateTemplateMessagingTemplatesPostData,
        OperationError<CreateTemplateMessagingTemplatesPostError>,
        MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTemplateMessagingTemplatesPostSchema,
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateTemplateMessagingTemplatesPostData,
          OperationError<CreateTemplateMessagingTemplatesPostError>,
          MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Template
     * @description Create a new message template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateTemplateMessagingTemplatesPostSchema,
            CreateTemplateMessagingTemplatesPostBody,
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostParameters,
            OperationError<CreateTemplateMessagingTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Template
     * @description Create a new message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.templatesService.createTemplateMessagingTemplatesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.templatesService.createTemplateMessagingTemplatesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTemplateMessagingTemplatesPostSchema,
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateTemplateMessagingTemplatesPostData,
            CreateTemplateMessagingTemplatesPostError,
            MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateTemplateMessagingTemplatesPostSchema,
              CreateTemplateMessagingTemplatesPostBody,
              CreateTemplateMessagingTemplatesPostData,
              CreateTemplateMessagingTemplatesPostParameters,
              OperationError<CreateTemplateMessagingTemplatesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateTemplateMessagingTemplatesPostData,
          CreateTemplateMessagingTemplatesPostError,
          MutationVariables<CreateTemplateMessagingTemplatesPostBody, CreateTemplateMessagingTemplatesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateTemplateMessagingTemplatesPostSchema;
    types: {
      parameters: CreateTemplateMessagingTemplatesPostParameters;
      data: CreateTemplateMessagingTemplatesPostData;
      error: CreateTemplateMessagingTemplatesPostError;
      body: CreateTemplateMessagingTemplatesPostBody;
    };
  };
  /**
   * @summary Get Template
   * @description Get a message template by ID.
   */
  getTemplateMessagingTemplatesTemplateIdGet: {
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetTemplateMessagingTemplatesTemplateIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetTemplateMessagingTemplatesTemplateIdGetSchema,
        options: {
          parameters: GetTemplateMessagingTemplatesTemplateIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >
    ): Promise<
      RequestFnResponse<GetTemplateMessagingTemplatesTemplateIdGetData, GetTemplateMessagingTemplatesTemplateIdGetError>
    >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ): ServiceOperationQueryKey<
      GetTemplateMessagingTemplatesTemplateIdGetSchema,
      GetTemplateMessagingTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTemplateMessagingTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetTemplateMessagingTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetTemplateMessagingTemplatesTemplateIdGetSchema,
      GetTemplateMessagingTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters,
      TQueryFnData = GetTemplateMessagingTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters,
      TQueryFnData = GetTemplateMessagingTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetTotal = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetByParametersTotal = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetResults = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetCombinedResults = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetTemplateMessagingTemplatesTemplateIdGetSchema,
          GetTemplateMessagingTemplatesTemplateIdGetParameters,
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetTemplateMessagingTemplatesTemplateIdGetData, GetTemplateMessagingTemplatesTemplateIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<
            GetTemplateMessagingTemplatesTemplateIdGetData,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetTemplateMessagingTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters,
      TData = GetTemplateMessagingTemplatesTemplateIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError,
          OperationInfiniteData<TData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetTemplateMessagingTemplatesTemplateIdGetParameters>,
      OperationError<GetTemplateMessagingTemplatesTemplateIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Template
     * @description Get a message template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetData = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getTemplateMessagingTemplatesTemplateIdGetCombinedData = qraft.templatesService.getTemplateMessagingTemplatesTemplateIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getTemplateMessagingTemplatesTemplateIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetTemplateMessagingTemplatesTemplateIdGetSchema,
          GetTemplateMessagingTemplatesTemplateIdGetParameters,
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<
              GetTemplateMessagingTemplatesTemplateIdGetData,
              GetTemplateMessagingTemplatesTemplateIdGetError
            >,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<GetTemplateMessagingTemplatesTemplateIdGetData>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<GetTemplateMessagingTemplatesTemplateIdGetData>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters
      >
    >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetTemplateMessagingTemplatesTemplateIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<
        GetTemplateMessagingTemplatesTemplateIdGetData,
        GetTemplateMessagingTemplatesTemplateIdGetParameters
      >
    >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ): GetTemplateMessagingTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ):
      | OperationInfiniteData<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetTemplateMessagingTemplatesTemplateIdGetSchema,
              GetTemplateMessagingTemplatesTemplateIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetTemplateMessagingTemplatesTemplateIdGetData,
                    GetTemplateMessagingTemplatesTemplateIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetTemplateMessagingTemplatesTemplateIdGetSchema,
              GetTemplateMessagingTemplatesTemplateIdGetParameters
            >,
            data: GetTemplateMessagingTemplatesTemplateIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
    ):
      | QueryState<GetTemplateMessagingTemplatesTemplateIdGetData, GetTemplateMessagingTemplatesTemplateIdGetError>
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetTemplateMessagingTemplatesTemplateIdGetData,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
          GetTemplateMessagingTemplatesTemplateIdGetError
        >
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
        | ServiceOperationQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetTemplateMessagingTemplatesTemplateIdGetData> | undefined,
        NoInfer<DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetTemplateMessagingTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetTemplateMessagingTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetTemplateMessagingTemplatesTemplateIdGetData,
              GetTemplateMessagingTemplatesTemplateIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetTemplateMessagingTemplatesTemplateIdGetData,
                GetTemplateMessagingTemplatesTemplateIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<
          GetTemplateMessagingTemplatesTemplateIdGetData,
          GetTemplateMessagingTemplatesTemplateIdGetParameters
        >
      | undefined;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      updater: Updater<
        NoInfer<GetTemplateMessagingTemplatesTemplateIdGetData> | undefined,
        NoInfer<GetTemplateMessagingTemplatesTemplateIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetTemplateMessagingTemplatesTemplateIdGetData | undefined>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetTemplateMessagingTemplatesTemplateIdGetSchema,
        GetTemplateMessagingTemplatesTemplateIdGetData,
        TInfinite,
        GetTemplateMessagingTemplatesTemplateIdGetParameters,
        GetTemplateMessagingTemplatesTemplateIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): void;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get Template
     * @description Get a message template by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetTemplateMessagingTemplatesTemplateIdGetSchema,
            GetTemplateMessagingTemplatesTemplateIdGetData,
            TInfinite,
            GetTemplateMessagingTemplatesTemplateIdGetParameters,
            GetTemplateMessagingTemplatesTemplateIdGetError
          >
    ): number;
    schema: GetTemplateMessagingTemplatesTemplateIdGetSchema;
    types: {
      parameters: GetTemplateMessagingTemplatesTemplateIdGetParameters;
      data: GetTemplateMessagingTemplatesTemplateIdGetData;
      error: GetTemplateMessagingTemplatesTemplateIdGetError;
    };
  };
  /**
   * @summary Update Template
   * @description Update a message template.
   */
  updateTemplateMessagingTemplatesTemplateIdPut: {
    /**
     * @summary Update Template
     * @description Update a message template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateTemplateMessagingTemplatesTemplateIdPutBody,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateTemplateMessagingTemplatesTemplateIdPutBody,
          UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateTemplateMessagingTemplatesTemplateIdPutData,
          UpdateTemplateMessagingTemplatesTemplateIdPutError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        UpdateTemplateMessagingTemplatesTemplateIdPutError
      >
    >;
    /**
     * @summary Update Template
     * @description Update a message template.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateTemplateMessagingTemplatesTemplateIdPutParameters> | void
    ): ServiceOperationMutationKey<
      UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
      UpdateTemplateMessagingTemplatesTemplateIdPutParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateTemplateMessagingTemplatesTemplateIdPutBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateTemplateMessagingTemplatesTemplateIdPutParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
        TVariables,
        OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateTemplateMessagingTemplatesTemplateIdPutData,
      OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateTemplateMessagingTemplatesTemplateIdPutBody,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
        TVariables,
        OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
        TContext
      >
    ): UseMutationResult<
      UpdateTemplateMessagingTemplatesTemplateIdPutData,
      OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutTotal = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutTotal = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutPendingMutationVariables = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateTemplateMessagingTemplatesTemplateIdPutMutationData = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateTemplateMessagingTemplatesTemplateIdPutData,
        OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
        MutationVariables<
          UpdateTemplateMessagingTemplatesTemplateIdPutBody,
          UpdateTemplateMessagingTemplatesTemplateIdPutParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateTemplateMessagingTemplatesTemplateIdPutData,
          OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
          MutationVariables<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update Template
     * @description Update a message template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
            OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Template
     * @description Update a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.templatesService.updateTemplateMessagingTemplatesTemplateIdPut.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
      ):
        | Mutation<
            UpdateTemplateMessagingTemplatesTemplateIdPutData,
            UpdateTemplateMessagingTemplatesTemplateIdPutError,
            MutationVariables<
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateTemplateMessagingTemplatesTemplateIdPutSchema,
              UpdateTemplateMessagingTemplatesTemplateIdPutBody,
              UpdateTemplateMessagingTemplatesTemplateIdPutData,
              UpdateTemplateMessagingTemplatesTemplateIdPutParameters,
              OperationError<UpdateTemplateMessagingTemplatesTemplateIdPutError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateTemplateMessagingTemplatesTemplateIdPutData,
          UpdateTemplateMessagingTemplatesTemplateIdPutError,
          MutationVariables<
            UpdateTemplateMessagingTemplatesTemplateIdPutBody,
            UpdateTemplateMessagingTemplatesTemplateIdPutParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateTemplateMessagingTemplatesTemplateIdPutSchema;
    types: {
      parameters: UpdateTemplateMessagingTemplatesTemplateIdPutParameters;
      data: UpdateTemplateMessagingTemplatesTemplateIdPutData;
      error: UpdateTemplateMessagingTemplatesTemplateIdPutError;
      body: UpdateTemplateMessagingTemplatesTemplateIdPutBody;
    };
  };
  /**
   * @summary Delete Template
   * @description Delete a message template.
   */
  deleteTemplateMessagingTemplatesTemplateIdDelete: {
    /**
     * @summary Delete Template
     * @description Delete a message template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteError
        >
      >
    ): Promise<
      RequestFnResponse<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteError
      >
    >;
    /**
     * @summary Delete Template
     * @description Delete a message template.
     */
    getMutationKey(
      parameters: DeepReadonly<DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters> | void
    ): ServiceOperationMutationKey<
      DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
      DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteTemplateMessagingTemplatesTemplateIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
        TVariables,
        OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
      OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
        TVariables,
        OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
      OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeleteTotal = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeleteTotal = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeletePendingMutationVariables = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteTemplateMessagingTemplatesTemplateIdDeleteMutationData = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
        OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
        MutationVariables<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
          OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
          MutationVariables<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Delete Template
     * @description Delete a message template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
            OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete Template
     * @description Delete a message template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.templatesService.deleteTemplateMessagingTemplatesTemplateIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteError,
            MutationVariables<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
              DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters,
              OperationError<DeleteTemplateMessagingTemplatesTemplateIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteTemplateMessagingTemplatesTemplateIdDeleteData,
          DeleteTemplateMessagingTemplatesTemplateIdDeleteError,
          MutationVariables<
            DeleteTemplateMessagingTemplatesTemplateIdDeleteBody,
            DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters
          >,
          TContext
        >
      >;
    };
    schema: DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema;
    types: {
      parameters: DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters;
      data: DeleteTemplateMessagingTemplatesTemplateIdDeleteData;
      error: DeleteTemplateMessagingTemplatesTemplateIdDeleteError;
      body: DeleteTemplateMessagingTemplatesTemplateIdDeleteBody;
    };
  };
  /**
   * @summary Preview Template
   * @description Preview a template with given variables.
   */
  previewTemplateMessagingTemplatesPreviewPost: {
    /**
     * @summary Preview Template
     * @description Preview a template with given variables.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        PreviewTemplateMessagingTemplatesPreviewPostBody,
        PreviewTemplateMessagingTemplatesPreviewPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: PreviewTemplateMessagingTemplatesPreviewPostSchema,
        options: ServiceOperationMutationFnOptions<
          PreviewTemplateMessagingTemplatesPreviewPostBody,
          PreviewTemplateMessagingTemplatesPreviewPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          PreviewTemplateMessagingTemplatesPreviewPostData,
          PreviewTemplateMessagingTemplatesPreviewPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        PreviewTemplateMessagingTemplatesPreviewPostData,
        PreviewTemplateMessagingTemplatesPreviewPostError
      >
    >;
    /**
     * @summary Preview Template
     * @description Preview a template with given variables.
     */
    getMutationKey(
      parameters: DeepReadonly<PreviewTemplateMessagingTemplatesPreviewPostParameters> | void
    ): ServiceOperationMutationKey<
      PreviewTemplateMessagingTemplatesPreviewPostSchema,
      PreviewTemplateMessagingTemplatesPreviewPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends PreviewTemplateMessagingTemplatesPreviewPostBody, TContext = unknown>(
      parameters: DeepReadonly<PreviewTemplateMessagingTemplatesPreviewPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        PreviewTemplateMessagingTemplatesPreviewPostSchema,
        PreviewTemplateMessagingTemplatesPreviewPostData,
        PreviewTemplateMessagingTemplatesPreviewPostParameters,
        TVariables,
        OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
        TContext
      >
    ): UseMutationResult<
      PreviewTemplateMessagingTemplatesPreviewPostData,
      OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        PreviewTemplateMessagingTemplatesPreviewPostBody,
        PreviewTemplateMessagingTemplatesPreviewPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PreviewTemplateMessagingTemplatesPreviewPostSchema,
        PreviewTemplateMessagingTemplatesPreviewPostData,
        PreviewTemplateMessagingTemplatesPreviewPostParameters,
        TVariables,
        OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
        TContext
      >
    ): UseMutationResult<
      PreviewTemplateMessagingTemplatesPreviewPostData,
      OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostTotal = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostTotal = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewTemplateMessagingTemplatesPreviewPostSchema,
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostPendingMutationVariables = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const previewTemplateMessagingTemplatesPreviewPostMutationData = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PreviewTemplateMessagingTemplatesPreviewPostData,
        OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
        MutationVariables<
          PreviewTemplateMessagingTemplatesPreviewPostBody,
          PreviewTemplateMessagingTemplatesPreviewPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewTemplateMessagingTemplatesPreviewPostSchema,
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PreviewTemplateMessagingTemplatesPreviewPostData,
          OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
          MutationVariables<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Preview Template
     * @description Preview a template with given variables.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PreviewTemplateMessagingTemplatesPreviewPostSchema,
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostParameters,
            OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Preview Template
     * @description Preview a template with given variables.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.templatesService.previewTemplateMessagingTemplatesPreviewPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewTemplateMessagingTemplatesPreviewPostSchema,
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
      ):
        | Mutation<
            PreviewTemplateMessagingTemplatesPreviewPostData,
            PreviewTemplateMessagingTemplatesPreviewPostError,
            MutationVariables<
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PreviewTemplateMessagingTemplatesPreviewPostSchema,
              PreviewTemplateMessagingTemplatesPreviewPostBody,
              PreviewTemplateMessagingTemplatesPreviewPostData,
              PreviewTemplateMessagingTemplatesPreviewPostParameters,
              OperationError<PreviewTemplateMessagingTemplatesPreviewPostError>,
              TContext
            >
      ): Array<
        Mutation<
          PreviewTemplateMessagingTemplatesPreviewPostData,
          PreviewTemplateMessagingTemplatesPreviewPostError,
          MutationVariables<
            PreviewTemplateMessagingTemplatesPreviewPostBody,
            PreviewTemplateMessagingTemplatesPreviewPostParameters
          >,
          TContext
        >
      >;
    };
    schema: PreviewTemplateMessagingTemplatesPreviewPostSchema;
    types: {
      parameters: PreviewTemplateMessagingTemplatesPreviewPostParameters;
      data: PreviewTemplateMessagingTemplatesPreviewPostData;
      error: PreviewTemplateMessagingTemplatesPreviewPostError;
      body: PreviewTemplateMessagingTemplatesPreviewPostBody;
    };
  };
}
/**
 * @summary List Templates
 * @description List message templates with optional filters.
 */
export const listTemplatesMessagingTemplatesGet = {
  schema: {
    method: 'get',
    url: '/messaging/templates/',
  },
} as {
  schema: ListTemplatesMessagingTemplatesGetSchema;
  [QraftServiceOperationsToken]: TemplatesService['listTemplatesMessagingTemplatesGet'];
};
/**
 * @summary Create Template
 * @description Create a new message template.
 */
export const createTemplateMessagingTemplatesPost = {
  schema: {
    method: 'post',
    url: '/messaging/templates/',
    mediaType: ['application/json'],
  },
} as {
  schema: CreateTemplateMessagingTemplatesPostSchema;
  [QraftServiceOperationsToken]: TemplatesService['createTemplateMessagingTemplatesPost'];
};
/**
 * @summary Get Template
 * @description Get a message template by ID.
 */
export const getTemplateMessagingTemplatesTemplateIdGet = {
  schema: {
    method: 'get',
    url: '/messaging/templates/{template_id}',
  },
} as {
  schema: GetTemplateMessagingTemplatesTemplateIdGetSchema;
  [QraftServiceOperationsToken]: TemplatesService['getTemplateMessagingTemplatesTemplateIdGet'];
};
/**
 * @summary Update Template
 * @description Update a message template.
 */
export const updateTemplateMessagingTemplatesTemplateIdPut = {
  schema: {
    method: 'put',
    url: '/messaging/templates/{template_id}',
    mediaType: ['application/json'],
  },
} as {
  schema: UpdateTemplateMessagingTemplatesTemplateIdPutSchema;
  [QraftServiceOperationsToken]: TemplatesService['updateTemplateMessagingTemplatesTemplateIdPut'];
};
/**
 * @summary Delete Template
 * @description Delete a message template.
 */
export const deleteTemplateMessagingTemplatesTemplateIdDelete = {
  schema: {
    method: 'delete',
    url: '/messaging/templates/{template_id}',
  },
} as {
  schema: DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema;
  [QraftServiceOperationsToken]: TemplatesService['deleteTemplateMessagingTemplatesTemplateIdDelete'];
};
/**
 * @summary Preview Template
 * @description Preview a template with given variables.
 */
export const previewTemplateMessagingTemplatesPreviewPost = {
  schema: {
    method: 'post',
    url: '/messaging/templates/preview',
    mediaType: ['application/json'],
  },
} as {
  schema: PreviewTemplateMessagingTemplatesPreviewPostSchema;
  [QraftServiceOperationsToken]: TemplatesService['previewTemplateMessagingTemplatesPreviewPost'];
};
export const templatesService = {
  listTemplatesMessagingTemplatesGet,
  createTemplateMessagingTemplatesPost,
  getTemplateMessagingTemplatesTemplateIdGet,
  updateTemplateMessagingTemplatesTemplateIdPut,
  deleteTemplateMessagingTemplatesTemplateIdDelete,
  previewTemplateMessagingTemplatesPreviewPost,
} as const;
type ListTemplatesMessagingTemplatesGetSchema = {
  method: 'get';
  url: '/messaging/templates/';
};
type ListTemplatesMessagingTemplatesGetParameters = paths['/messaging/templates/']['get']['parameters'];
type ListTemplatesMessagingTemplatesGetData =
  paths['/messaging/templates/']['get']['responses']['200']['content']['application/json'];
type ListTemplatesMessagingTemplatesGetError =
  paths['/messaging/templates/']['get']['responses']['422']['content']['application/json'];
type CreateTemplateMessagingTemplatesPostSchema = {
  method: 'post';
  url: '/messaging/templates/';
  mediaType: ['application/json'];
};
type CreateTemplateMessagingTemplatesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateTemplateMessagingTemplatesPostData =
  paths['/messaging/templates/']['post']['responses']['200']['content']['application/json'];
type CreateTemplateMessagingTemplatesPostError =
  paths['/messaging/templates/']['post']['responses']['422']['content']['application/json'];
type CreateTemplateMessagingTemplatesPostBody =
  paths['/messaging/templates/']['post']['requestBody']['content']['application/json'];
type GetTemplateMessagingTemplatesTemplateIdGetSchema = {
  method: 'get';
  url: '/messaging/templates/{template_id}';
};
type GetTemplateMessagingTemplatesTemplateIdGetParameters =
  paths['/messaging/templates/{template_id}']['get']['parameters'];
type GetTemplateMessagingTemplatesTemplateIdGetData =
  paths['/messaging/templates/{template_id}']['get']['responses']['200']['content']['application/json'];
type GetTemplateMessagingTemplatesTemplateIdGetError =
  paths['/messaging/templates/{template_id}']['get']['responses']['422']['content']['application/json'];
type UpdateTemplateMessagingTemplatesTemplateIdPutSchema = {
  method: 'put';
  url: '/messaging/templates/{template_id}';
  mediaType: ['application/json'];
};
type UpdateTemplateMessagingTemplatesTemplateIdPutParameters =
  paths['/messaging/templates/{template_id}']['put']['parameters'];
type UpdateTemplateMessagingTemplatesTemplateIdPutData =
  paths['/messaging/templates/{template_id}']['put']['responses']['200']['content']['application/json'];
type UpdateTemplateMessagingTemplatesTemplateIdPutError =
  paths['/messaging/templates/{template_id}']['put']['responses']['422']['content']['application/json'];
type UpdateTemplateMessagingTemplatesTemplateIdPutBody =
  paths['/messaging/templates/{template_id}']['put']['requestBody']['content']['application/json'];
type DeleteTemplateMessagingTemplatesTemplateIdDeleteSchema = {
  method: 'delete';
  url: '/messaging/templates/{template_id}';
};
type DeleteTemplateMessagingTemplatesTemplateIdDeleteParameters =
  paths['/messaging/templates/{template_id}']['delete']['parameters'];
type DeleteTemplateMessagingTemplatesTemplateIdDeleteData = null;
type DeleteTemplateMessagingTemplatesTemplateIdDeleteError =
  paths['/messaging/templates/{template_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteTemplateMessagingTemplatesTemplateIdDeleteBody = undefined;
type PreviewTemplateMessagingTemplatesPreviewPostSchema = {
  method: 'post';
  url: '/messaging/templates/preview';
  mediaType: ['application/json'];
};
type PreviewTemplateMessagingTemplatesPreviewPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type PreviewTemplateMessagingTemplatesPreviewPostData =
  paths['/messaging/templates/preview']['post']['responses']['200']['content']['application/json'];
type PreviewTemplateMessagingTemplatesPreviewPostError =
  paths['/messaging/templates/preview']['post']['responses']['422']['content']['application/json'];
type PreviewTemplateMessagingTemplatesPreviewPostBody =
  paths['/messaging/templates/preview']['post']['requestBody']['content']['application/json'];
